import { render, staticRenderFns } from "./MainSwitch.vue?vue&type=template&id=2084b0a6"
import script from "./MainSwitch.vue?vue&type=script&lang=js"
export * from "./MainSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports